import { SaleChangeStatusEnum, SaleChangeTypeEnum } from '@src/core/buyerApiClient';
import { getOrderSaleItems } from '@src/domains/orders/core/getOrderSaleItems';
import type { Order } from '@src/domains/orders/types/order';

export const getOrderSaleChangesAmount = (order: Order) => {
  if (!order.sales.length) return [];

  const rescheduleSaleChanges = getOrderSaleItems(order)
    .flatMap((item) => item.saleChanges)
    .filter(
      (saleChange) =>
        saleChange.status === SaleChangeStatusEnum.Applied &&
        saleChange.type === SaleChangeTypeEnum.Reschedule &&
        saleChange.amount.amountCents > 0,
    );

  const amoutsRecord = rescheduleSaleChanges.reduce((acc, saleChange) => {
    acc[saleChange.id] = saleChange.amount.amountCents;
    return acc;
  }, {} as Record<string, number>);

  return Object.entries(amoutsRecord);
};
